import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { PreviewPageType } from '@dev/ee-api/ee-api-models';

import { map } from 'lodash-es';

import { getLandingPageList } from '@/store/landingPageList/actions';
import { getApiPath } from '@/services/Secuirty';
import { ImageWrapper } from './useTemplatesList';
import { TemplatesList } from '../FormStep3Interfaces';

export const useLandingPageList = (pageTemplateType:PreviewPageType, landingPageSearch):TemplatesList[] => {
    const { templatesList, submitLandingPagesList, alreadySubscribedLandingPagesList } = useSelector(getLandingPageList);
    const { t } = useTranslation();

    const list = {
        ActivationViaEmail: templatesList,
        AlreadySubscribed: alreadySubscribedLandingPagesList,
        FormSubmit: submitLandingPagesList
    }

    if (!list[pageTemplateType].length && !!landingPageSearch) {
        return ([{
            label: t('noresults'),
            image: null,
            value: "noresults",
        }]);
    }

    if (!list[pageTemplateType].length) {
        return [];
    }

   return map(list[pageTemplateType], template => ({
        image: <ImageWrapper><img src={`${getApiPath()}/userfile${encodeURI(template.Thumbnail)}`} /></ImageWrapper>,
        label: template.Name,
        value: template.Name,
        link: template.Link
    }));
}